import classNames from "classnames";

export const headerPageClasses = (hasSubTitle: boolean) => ({
  subHeaderContainer: classNames("md:flex items-center mb-4", {
    "justify-between": hasSubTitle,
    "justify-end": !hasSubTitle,
  }),
  actions: "flex gap-2 justify-end",
});
